var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showItem)?_c('v-text-field',{attrs:{"label":_vm.item.label,"value":_vm.computedValue,"readonly":"","disabled":!_vm.updateTrigger || _vm.disabled},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [(_vm.item.required)?_c('span',{staticClass:"red--text"},[_vm._v("*")]):_vm._e()]},proxy:true}],null,false,3265864401)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }